import React, { FC, useEffect, useState } from "react";
import {
  RadioButtonItem,
  WrapperRadio,
  Radio,
  RadioButtonCircle,
} from "./RadioButtonSingle.styles";

interface RadioButtonSingleProps {
  name: string;
  value: string;
  defaultValue?: string;
  selectedClick?: string;
  disabled?: boolean;
}

const RadioButtonSingle: FC<RadioButtonSingleProps> = ({
  name,
  value,
  defaultValue,
  selectedClick,
  disabled = false,
}) => {
  const [select, setSelect] = useState(defaultValue);

  useEffect(() => {
    if (selectedClick) handleSelectChange();
  }, [selectedClick]);

  const handleSelectChange = () => {
    const _value = selectedClick;

    setSelect(_value);
  };

  return (
    <WrapperRadio>
      <RadioButtonItem>
        <Radio
          type='radio'
          name={name}
          value={value}
          checked={select === value}
          onChange={() => handleSelectChange()}
          disabled={disabled}
        />
        <RadioButtonCircle />
      </RadioButtonItem>
    </WrapperRadio>
  );
};

export default RadioButtonSingle;
